var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.3136L21.6 7.64693V9.59997H2.4V7.64693L12 2.3136ZM3.6 8.39997V8.35302L12 3.68635L20.4 8.35302V8.39997H3.6ZM4.9 18V12H6.1V18H4.9ZM11.4 18V12H12.6V18H11.4ZM17.9 18V12H19.1V18H17.9ZM22 20.4V21.6H2V20.4H22Z"
  })));
};
export default SvgBank;